import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=1d04d7ba"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
import style0 from "./Category.vue?vue&type=style&index=0&id=1d04d7ba&prod&lang=scss"
import style1 from "./Category.vue?vue&type=style&index=1&id=1d04d7ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryHub: require('/app/components/CategoryHub.vue').default,TruncateText: require('/app/components/TruncateText.vue').default,CategoryList: require('/app/components/CategoryList.vue').default,ProductSliderList: require('/app/components/ProductSliderList.vue').default,ProductList: require('/app/components/ProductList.vue').default,FaqList: require('/app/components/FaqList.vue').default,CategoryHubTile: require('/app/components/CategoryHubTile.vue').default,CategoryListItem: require('/app/components/CategoryListItem.vue').default,HomeTrustBar: require('/app/components/HomeTrustBar.vue').default})
